import { render, staticRenderFns } from "./eye-color.vue?vue&type=template&id=6a5f9327&scoped=true"
import script from "./eye-color.vue?vue&type=script&lang=ts"
export * from "./eye-color.vue?vue&type=script&lang=ts"
import style0 from "./eye-color.vue?vue&type=style&index=0&id=6a5f9327&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5f9327",
  null
  
)

export default component.exports